/// <amd-module name="Feed/Legacy/Protocols/Components/PackageAttribute" />
import * as React from "react";

import { css } from "VSSUI/Util";

export interface IPackageAttributeProps {
    title: string;
    className?: string;
}

export class PackageAttribute extends React.PureComponent<IPackageAttributeProps> {
    public render(): JSX.Element {
        // Only render if protocol metadata has content
        if (this.props.children) {
            return (
                <div className={css("package-attribute", this.props.className)} aria-label={this.props.title}>
                    {this.props.title ? <h2 className="package-attribute-title">{this.props.title}</h2> : null}
                    <div className="package-attribute-content">{this.props.children}</div>
                </div>
            );
        } else {
            return null;
        }
    }
}
